var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_box" }, [
    _c("div", { staticClass: "content_box" }, [
      _c(
        "div",
        { staticClass: "left_form" },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.formOption.busy } },
            [
              _c(
                "a-form",
                {
                  ref: "form",
                  attrs: {
                    form: _vm.form,
                    "label-col": { span: 4 },
                    "wrapper-col": { span: 18 },
                  },
                },
                [
                  _c("div", { staticClass: "form_title" }, [
                    _vm._v("文章设置"),
                  ]),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "是否外链" } },
                        [
                          _c("a-switch", {
                            on: { change: _vm.handleIsHretChange },
                            model: {
                              value: _vm.isHret,
                              callback: function ($$v) {
                                _vm.isHret = $$v
                              },
                              expression: "isHret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isHret
                    ? _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "员工二维码" } },
                            [
                              _c("a-switch", {
                                on: {
                                  change: _vm.handleIsEmployeeQrcodeChange,
                                },
                                model: {
                                  value: _vm.isEmployeeQrcode,
                                  callback: function ($$v) {
                                    _vm.isEmployeeQrcode = $$v
                                  },
                                  expression: "isEmployeeQrcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "分类" } },
                        [
                          _c("a-tree-select", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["carTypeId", _vm.rules.carTypeId],
                                expression: "['carTypeId',rules.carTypeId]",
                              },
                            ],
                            attrs: {
                              "allow-clear": "",
                              "dropdown-style": {
                                maxHeight: "300px",
                                overflow: "auto",
                              },
                              placeholder: "请选择分类",
                              treeData: _vm.treeData,
                              replaceFields: {
                                children: "children",
                                title: "codeName",
                                key: "codeId",
                                value: "codeId",
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isHret
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "外链地址" } },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["hretUrl", _vm.rules.hretUrl],
                                        expression:
                                          "['hretUrl', rules.hretUrl]",
                                      },
                                    ],
                                    attrs: { placeholder: "请输入外链地址" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      this.isHret
                        ? _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "文章标题" } },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["title"],
                                        expression: "['title']",
                                      },
                                    ],
                                    attrs: {
                                      maxLength: 50,
                                      placeholder: "最多输入50个字符...",
                                    },
                                    model: {
                                      value: _vm.title,
                                      callback: function ($$v) {
                                        _vm.title = $$v
                                      },
                                      expression: "title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "文章标题" } },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["title", _vm.rules.title],
                                        expression: "['title', rules.title]",
                                      },
                                    ],
                                    attrs: {
                                      maxLength: 50,
                                      placeholder: "最多输入50个字符...",
                                    },
                                    model: {
                                      value: _vm.title,
                                      callback: function ($$v) {
                                        _vm.title = $$v
                                      },
                                      expression: "title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      this.isHret
                        ? _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "文章内容" } },
                                [
                                  _c("wangEdit", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["contentDetail"],
                                        expression: "['contentDetail']",
                                      },
                                    ],
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "文章内容" } },
                                [
                                  _c("wangEdit", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: [
                                          "contentDetail",
                                          _vm.rules.contentDetail,
                                        ],
                                        expression:
                                          "['contentDetail', rules.contentDetail]",
                                      },
                                    ],
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form_title" }, [
                    _vm._v("文章分享设置"),
                  ]),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "分享标题" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["shareTitle", _vm.rules.shareTitle],
                                expression: "['shareTitle', rules.shareTitle]",
                              },
                            ],
                            attrs: { disabled: false },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("div", { staticClass: "need pa" }, [_vm._v("*")]),
                      _c(
                        "a-form-item",
                        { staticClass: "pr", attrs: { label: "分享封面" } },
                        [
                          _c("input", {
                            ref: "imgUploader",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", accept: "image/*" },
                            on: { change: _vm.handleImgChange },
                          }),
                          !this.shareCoverImg
                            ? _c(
                                "div",
                                {
                                  staticClass: "img_uploader_box",
                                  on: { click: _vm.uploaderData },
                                },
                                [_vm._v(" 上传 ")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "upload_img",
                                  on: { click: _vm.uploaderData },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.api.temp.FILE_PATH +
                                        _vm.shareCoverImg,
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                          _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v(
                              "推荐尺寸160*180，支持jpg、png格式，不超过10M"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "分享文案" } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "shareDescribe",
                                  _vm.rules.shareDescribe,
                                ],
                                expression:
                                  "['shareDescribe', rules.shareDescribe]",
                              },
                            ],
                            attrs: { maxLength: 39, disabled: false },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isHret
                    ? _c(
                        "div",
                        { staticClass: "label_box" },
                        [
                          _c(
                            "a-row",
                            { attrs: { gutter: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "标签规则 客户",
                                    "label-col": { span: 4 },
                                    "wrapper-col": { span: 18 },
                                  },
                                },
                                _vm._l(_vm.labelList, function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "12px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "label_item_box" },
                                        [
                                          _c("a-select", {
                                            staticStyle: { height: "38px" },
                                            attrs: {
                                              allowClear: true,
                                              options: _vm.ruleIdOption,
                                            },
                                            model: {
                                              value: item.ruleId,
                                              callback: function ($$v) {
                                                _vm.$set(item, "ruleId", $$v)
                                              },
                                              expression: "item.ruleId",
                                            },
                                          }),
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                margin: "0 12px",
                                                "line-height": "30px",
                                              },
                                            },
                                            [_vm._v("时")]
                                          ),
                                          _c("tagPicker", {
                                            model: {
                                              value: item.tagId,
                                              callback: function ($$v) {
                                                _vm.$set(item, "tagId", $$v)
                                              },
                                              expression: "item.tagId",
                                            },
                                          }),
                                          _c("a-icon", {
                                            staticClass: "delete_icon",
                                            attrs: { type: "minus-circle" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delLabelRule(index)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-row",
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    margin: "0 auto 12px",
                                    display: "block",
                                  },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addLabelRule },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "plus-circle" },
                                  }),
                                  _vm._v(" 添加标签规则 "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "是否全部可见" } },
                        [
                          _c("a-switch", {
                            on: { change: _vm.handleIsAllVisibleChange },
                            model: {
                              value: _vm.isAllVisible,
                              callback: function ($$v) {
                                _vm.isAllVisible = $$v
                              },
                              expression: "isAllVisible",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.isAllVisible
                    ? _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "可见部门" } },
                            [
                              _c("a-tree-select", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["deptList", _vm.rules.deptList],
                                    expression: "['deptList',rules.deptList]",
                                  },
                                ],
                                attrs: {
                                  "allow-clear": "",
                                  "show-search": "",
                                  "tree-checkable": "",
                                  "dropdown-style": {
                                    maxHeight: "300px",
                                    overflow: "auto",
                                  },
                                  "tree-data": _vm.deptTreeList,
                                  "search-placeholder": "请选择可见权限的部门",
                                  treeDefaultExpandAll: false,
                                  filterTreeNode: _vm.filterTreeNodeOption,
                                  treeDefaultExpandedKeys:
                                    _vm.defaultExpandedKeys,
                                  replaceFields: {
                                    children: "children",
                                    title: "deptName",
                                    key: "deptId",
                                    value: "deptId",
                                  },
                                },
                                on: {
                                  "update:treeDefaultExpandedKeys": function (
                                    $event
                                  ) {
                                    _vm.defaultExpandedKeys = $event
                                  },
                                  "update:tree-default-expanded-keys":
                                    function ($event) {
                                      _vm.defaultExpandedKeys = $event
                                    },
                                  change: _vm.handleDeptTree,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.publishStatus == 0 || _vm.publishStatus == 2
                ? _c(
                    "a-space",
                    { staticClass: "a-form-btn-box" },
                    [
                      _c("a-button", { on: { click: _vm.closePop } }, [
                        _vm._v("取消"),
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm._save },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "preview_box" }, [
        _c("div", { staticClass: "form_title" }, [_vm._v("页面预览")]),
        _c("div", { staticClass: "preview_phone" }, [
          _vm.isEmployeeQrcode
            ? _c("div", { staticClass: "author_box" }, [
                _vm._m(0),
                _c("div", { staticClass: "right" }, [
                  _c("span", { staticClass: "concat_me" }, [_vm._v("联系我")]),
                  _c(
                    "span",
                    { staticClass: "more" },
                    [_c("a-icon", { attrs: { type: "ellipsis" } })],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "content_box" }, [
            _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _c("p", { staticClass: "time" }, [_vm._v(_vm._s(_vm.nowTime))]),
            _c("p", {
              staticClass: "content",
              domProps: { innerHTML: _vm._s(_vm.contentDetail) },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", {
        staticClass: "header",
        attrs: { src: require("@/assets/img/moren.png") },
      }),
      _c("div", { staticClass: "name_box" }, [
        _c("div", { staticClass: "name" }, [_vm._v("员工姓名")]),
        _c("div", { staticClass: "company" }, [_vm._v("公司名称")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }